import { getClassNames } from '@websolutespa/bom-core';
import { useEventListener } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'framer-motion';
import React, { useCallback, useEffect, useId, useMemo, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { LlmAction } from '../../../types';
import { useActions } from '../../../useLlm/useActions';
import { Chunk, ChunkProps } from '../Chunk/chunk';

const USE_SCROLL_INTO_VIEW = true;

export const ChunkWrapper: React.FC<ChunkProps & {
  className?: string;
  stream?: boolean;
}> = ({ className, stream, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);
  const id = useId();
  const chunkId = `chunk-${id}`;
  const actions = useMemo(() => {
    return ((props.item as { actions?: LlmAction[] }).actions || []).map(x => {
      x.id = x.id || uuid();
      return x;
    });
  }, [props.item]);
  // console.log('ChunkWrapper.actions', actions);

  const { setWrapperNode } = useActions();

  const onScroll = useCallback(() => {
    const node = ref.current;
    if (node) {
      if (
        node.offsetHeight > 1,
        node.offsetTop - window.scrollY < window.innerHeight / 2 &&
        node.offsetTop + node.offsetHeight - window.scrollY > window.innerHeight / 2
      ) {
        // console.log(node.id, node.offsetTop - window.scrollY, node.offsetTop + node.offsetHeight - window.scrollY);
        // console.log('ChunkWrapper.id', node.id);
        setWrapperNode(node);
      }
    }
  }, [setWrapperNode]);

  useEventListener('scroll', onScroll);

  useEffect(() => {
    if (USE_SCROLL_INTO_VIEW && ref.current && props.chunkIndex === 0 && props.index === props.total - 1) {
      // console.log('scrollIntoView', USE_SCROLL_INTO_VIEW, ref.current, props);
      ref.current.scrollIntoView({
        behavior: 'instant',
        block: 'start',
        inline: 'start',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const classNames = getClassNames(className || `llm__inner llm__inner--${props.item.type}`);
  // console.log('ChunkWrapper.actions', actions);
  return (
    <div
      ref={ref}
      id={chunkId}
      className={classNames}
      data-message-role={props.role}
      data-message-index={props.index}
      data-chunk-index={props.chunkIndex}
      data-chunk-type={props.item.type}
      data-actions={JSON.stringify(actions)}
    >
      {stream ? (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <Chunk {...props} />
        </motion.div>
      ) : (
        <Chunk {...props} />
      )}
    </div>
  );
};

